export default {
    login: {
        username: "Nome de usuário",
        password: "Senha",
        button: "Entrar",
        error: "Erro ao logar, confira suas informações",
        page_title: "Kevi, Sua Opinião Vale Descontos",
        intro_title: "Valorizamos sua opinião!",
        intro_body: "Preencha o formulário e ganhe um bônus.",
        coupons_title: "Acompanhe os seus cupons!",
        coupons_body: "Acesse e confira os descontos já adquiridos.",
        invalid_link: "Link inválido.",
        used_link: "Link já utilizado",
    },
    form: {
        save_error: "Não foi possível enviar. Tente de novo em instantes.",
        save_error_table: "Confira a tabela: alguma célula não foi aceita.",
        page_title: "Kevi, sua opinião é muito importante!",
        submit: "Enviar",
        not_found: "Formulário não encontrado.",
        already_answered:
            "Você já respondeu essa enquete no dia <strong>{date}</strong>. Você poderá responder de novo <strong>{next}</strong>",
        unused_coupon:
            "Você ainda tem um cupom de desconto não utilizado. Você poderá responder novamente após utilizar o cupom atual.",
        thanks_title: "Obrigado!",
        thanks_message: "Sua opinião é muito importante!",
        coupon_prize:
            "{name}, você acaba de ganhar <strong>{prize}</strong> na sua próxima compra!",
        coupon_valid_until: "Cupom válido até {date}",
        developed_with: "Desenvolvido com",
    },
    user: {
        heading_known: "Gostaríamos de saber um pouco mais sobre você",
        heading: "Complete seus dados para finalizar",
        name: "Nome",
        name_placeholder: "Digite seu nome",
        name_error: "Por favor informe seu nome",
        last_name: "Sobrenome",
        last_name_placeholder: "Digite seu sobrenome",
        last_name_error: "Por favor informe seu sobrenome",
        email: "E-mail",
        email_placeholder: "Digite seu e-mail",
        email_error: "Por favor informe seu email",
        phone: "Celular",
        phone_search: "Buscar...",
        phone_no_results: "Nenhum resultado encontrado",
        phone_required: "Por favor informe seu celular",
        phone_invalid: "Por favor, informe um celular válido",
        birthdate: "Data de Nascimento",
        birthdate_placeholder: "xx/xx/xxxx",
        birthdate_error: "Por favor confira sua data de nascimento",
    },
    question: {
        yes: "Sim",
        no: "Não",
        select_option: "Selecione uma opção",
        select_options: "Selecione uma ou mais opções",
        select_at_least_one: "Selecione ao menos uma opção.",
        nps_low: "Não recomendaria",
        nps_high: "Recomendaria",
        ces_hard: "Extremamente difícil",
        ces_easy: "Extremamente fácil",
        file_drop: "Clique ou arraste seus arquivos aqui",
        file_uploading: "Enviando arquivos...",
        file_hint: "{types} — até {size} MB (máx. {max})",
        file_types_any: "Arquivos permitidos pela Kevi",
        file_types_image: "Imagens",
        file_types_image_dst: "Imagens ou bordado .DST",
        file_types_dst: "Bordado .DST",
        file_invalid_type: "{name}: formato não aceito",
        file_too_large: "{name}: excede {size} MB",
        file_too_many: "Você pode enviar no máximo {max} arquivo(s).",
        file_upload_error: "Não foi possível enviar os arquivos. Tente novamente.",
        table_row: "Linha {n}",
        table_add_row: "Adicionar linha",
        table_duplicate: "Duplicar linha",
        table_remove: "Remover linha",
        table_min_rows: "Preencha pelo menos {n} linha(s).",
        table_max_rows: "No máximo {n} linhas.",
        table_invalid_cells: "Confira {n} célula(s), começando por {where}.",
        table_formula_error: "Não foi possível calcular esta célula",
        table_paste_skipped: "{n} linha(s) não couberam na tabela.",
    },
};
